export default __webpack_public_path__ + "assets/media/channel-empty.88c029e1.png";